import { QueryKeys } from '@/constants/query-keys';
import { moviesApiService } from '@/services/(frontend)/movies/movie-api.service';
import { PagedListOfMovie } from '@cinemark/content-api-client';
import { useQuery } from '@tanstack/react-query';

export const useMoviesByIds = (cinemarkMovieIds: number[]): ReturnType<typeof useQuery<PagedListOfMovie>> => {
  return useQuery<PagedListOfMovie>({
    enabled: !!cinemarkMovieIds.length,
    queryFn: async ({ signal }) => {
      const response = await moviesApiService.getMovies({
        cinemarkMovieIds,
        pageSize: cinemarkMovieIds.length,
      }, signal);

      return response;
    },
    queryKey: QueryKeys.global.moviesByMovieIds(cinemarkMovieIds),
  });
};
